import { getConfig } from '@superbet-group/web.lib.config';

import { COMPLETE_REGISTRATION } from '@core/constants';
import User from '@models/user/User';
import { NotificationType } from '@models/user/enums';
import UserNotification from '@models/user/notifications/UserNotification';
import {
    addIdCard,
    addSms,
} from '@modules/userProfile/notifications/utils';
import { hasUserCompletedSecondStep } from '@accountFederation/modules/idCardVerification/shared/idCardRemainingDays';

export function getNotifications(user: User): UserNotification[] {
    const notifications: UserNotification[] = [];

    if (getConfig().countrySpecific.user.idCardVerification.isCompleteRegistrationNeededForKyc) {
        if (hasUserCompletedSecondStep(user)) {
            addSms(user, notifications);

            if (!user.isVerifiedIdCard) {
                addIdCard(user, notifications);
            }
        } else {
            notifications.push({
                title: COMPLETE_REGISTRATION,
                type: NotificationType.completeRegistration,
            });
        }
    } else {
        addIdCard(user, notifications);
        addSms(user, notifications);
    }

    return notifications;
}
